<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div>
  <h2 mat-dialog-title i18n>Annotation</h2>
</div>
<mat-dialog-content>
  <ng-container *ngIf="isLoaded; else loading">
      <div class="table-scroll">
        <table
          mat-table
          [dataSource]="dataSource"
          [trackBy]="trackByFilename"
          matSort
        >
          <ng-container matColumnDef="filename">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="filename"
            >
              File Name
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                [checked]="row.selected"
                [disabled]="row.isUsedInFilter"
                (change)="onChange($event.checked, row)"
              >
                <span [title]="row.filename">{{ row.filename }}</span>
              </mat-checkbox>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['filename']; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ['filename'];"></tr>
          
          <tr class="mat-mdc-row no-data-row" *matNoDataRow>
          <td class="mat-mdc-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            No Data found
          </td>
        </tr>
        </table>
      </div>
  </ng-container>
  <ng-template #loading>
    <div>Loading...</div>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <app-buttons
    name="Cancel"
    buttonType="mat-button"
    buttonStyle="btn-text"
    [isDisabled]="false"
    (buttonClickEvent)="onCancelClick()"
  ></app-buttons>
  <app-buttons
    name="OK"
    buttonType="mat-flat-button"
    [buttonStyle]="isDisabled ? 'btn-filled-small-disabled' : 'btn-filled-small'"
    [isDisabled]="isDisabled"
    (buttonClickEvent)="onOkClick()"
  ></app-buttons>
</mat-dialog-actions>
